import { cx } from "@linaria/core";

import * as styles from "./atom.bullets.style";
import { SliderComponentBulletTypes, SliderModel } from "@courses-pm2/api";
import { PostloadedImage } from "@pm2/compat";

type Props = {
  slides: SliderModel["slides"];

  activeIndex: number;
  bulletType: SliderComponentBulletTypes;

  onBulletClick: (index: number) => void;
};

export function Bullets(props: Props): React.JSX.Element {
  return (
    <ul className={styles.list} data-type={props.bulletType}>
      {props.slides.map((slide, index) => (
        <li key={index}>
          <button
            className={cx(
              styles.button,
              props.activeIndex === index && "active",
            )}
            onClick={() => props.onBulletClick(index)}
            aria-label={`Gå til slide ${index + 1}`}
          >
            <span
              className={cx(
                styles.bullet,
                props.activeIndex === index && "active",
              )}
              data-type={props.bulletType}
            >
              <span>
                {props.bulletType === "numbered" ? index + 1 : undefined}
                {props.bulletType === "thumb" && (
                  <PostloadedImage
                    alt=""
                    src={slide.src}
                    width={slide.width}
                    height={slide.height}
                    sizes="150px"
                  />
                )}
              </span>
            </span>
          </button>
        </li>
      ))}
    </ul>
  );
}
